(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode(".flash-side-nav .side-nav-hint-bar{transform:scale(1);transition:.3s cubic-bezier(.2,0,1,1)}.flash-side-nav .side-nav-hint-bar.side-nav-open{padding-left:0}.flash-side-nav .side-nav-hint-bar.side-nav-closed{padding-left:1.5rem}")),document.head.appendChild(e)}}catch(n){console.error("vite-plugin-css-injected-by-js",n)}})();
import { jsx, jsxs } from "react/jsx-runtime";
import { c as classNames } from "../../../../index-e71f83b5.js";
import { C as Collapse } from "../../../../Collapse-9e0c9fe4.js";
import FlashButton from "../../../atoms/buttons/FlashButton/FlashButton.js";
import { COMMON_CLASSNAME } from "../../../constants.js";
import "../../../../styles/assets/images/icons/material/designSystem/AccessTime.js";
import "../../../../styles/assets/images/icons/material/designSystem/AccessTimeFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/AccountCircle.js";
import "../../../../styles/assets/images/icons/material/designSystem/AccountCircleFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Add.js";
import "../../../../styles/assets/images/icons/material/designSystem/AddCircle.js";
import "../../../../styles/assets/images/icons/material/designSystem/AddCircleFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/AddLocation.js";
import "../../../../styles/assets/images/icons/material/designSystem/AddLocationFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/AdminPanelSettings.js";
import "../../../../styles/assets/images/icons/material/designSystem/AdminPanelSettingsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Analytics.js";
import "../../../../styles/assets/images/icons/material/designSystem/AnalyticsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Apartment.js";
import "../../../../styles/assets/images/icons/material/designSystem/Apps.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowBack.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowCircleLeft.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowCircleLeftFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowCircleRight.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowCircleRightFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowDownward.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowDropDown.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowDropUp.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowForward.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowUpward.js";
import "../../../../styles/assets/images/icons/material/designSystem/Bolt.js";
import "../../../../styles/assets/images/icons/material/designSystem/BoltFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/BugReport.js";
import "../../../../styles/assets/images/icons/material/designSystem/Business.js";
import "../../../../styles/assets/images/icons/material/designSystem/Calculate.js";
import "../../../../styles/assets/images/icons/material/designSystem/CalculateFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/CalendarTodayFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Cancel.js";
import "../../../../styles/assets/images/icons/material/designSystem/CancelFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/CheckCircle.js";
import "../../../../styles/assets/images/icons/material/designSystem/CheckCircleFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ChevronLeft.js";
import "../../../../styles/assets/images/icons/material/designSystem/ChevronRight.js";
import "../../../../styles/assets/images/icons/material/designSystem/Circle.js";
import "../../../../styles/assets/images/icons/material/designSystem/CircleFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Close.js";
import "../../../../styles/assets/images/icons/material/designSystem/CoPresent.js";
import "../../../../styles/assets/images/icons/material/designSystem/CoPresentFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ConfirmationNumber.js";
import "../../../../styles/assets/images/icons/material/designSystem/ConfirmationNumberFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ContactSupport.js";
import "../../../../styles/assets/images/icons/material/designSystem/ContactSupportFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ContentCopy.js";
import "../../../../styles/assets/images/icons/material/designSystem/CopyAll.js";
import "../../../../styles/assets/images/icons/material/designSystem/CreditCard.js";
import "../../../../styles/assets/images/icons/material/designSystem/CreditCardFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Dashboard.js";
import "../../../../styles/assets/images/icons/material/designSystem/DashboardFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Delete.js";
import "../../../../styles/assets/images/icons/material/designSystem/DeleteFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/DirectionsCar.js";
import "../../../../styles/assets/images/icons/material/designSystem/DirectionsCarFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/DirectionsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/DisabledByDefault.js";
import "../../../../styles/assets/images/icons/material/designSystem/DisabledByDefaultFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/DoNotDisturb.js";
import "../../../../styles/assets/images/icons/material/designSystem/Edit.js";
import "../../../../styles/assets/images/icons/material/designSystem/EditFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ElectricCar.js";
import "../../../../styles/assets/images/icons/material/designSystem/ElectricCarFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Error.js";
import "../../../../styles/assets/images/icons/material/designSystem/ErrorFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/EventFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ExpandContent.js";
import "../../../../styles/assets/images/icons/material/designSystem/ExpandLess.js";
import "../../../../styles/assets/images/icons/material/designSystem/ExpandMore.js";
import "../../../../styles/assets/images/icons/material/designSystem/Favorite.js";
import "../../../../styles/assets/images/icons/material/designSystem/FavoriteFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/FileCopy.js";
import "../../../../styles/assets/images/icons/material/designSystem/FileCopyFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/FilterAltFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/FirstPage.js";
import "../../../../styles/assets/images/icons/material/designSystem/Forward.js";
import "../../../../styles/assets/images/icons/material/designSystem/GarageHome.js";
import "../../../../styles/assets/images/icons/material/designSystem/GarageHomeFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/GridView.js";
import "../../../../styles/assets/images/icons/material/designSystem/Group.js";
import "../../../../styles/assets/images/icons/material/designSystem/GroupFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Help.js";
import "../../../../styles/assets/images/icons/material/designSystem/HelpFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/HideSource.js";
import "../../../../styles/assets/images/icons/material/designSystem/Home.js";
import "../../../../styles/assets/images/icons/material/designSystem/HomeFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Info.js";
import "../../../../styles/assets/images/icons/material/designSystem/InfoFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/IosShare.js";
import "../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowDown.js";
import "../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowLeft.js";
import { ReactComponent as ForwardRef } from "../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowRight.js";
import "../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowUp.js";
import "../../../../styles/assets/images/icons/material/designSystem/LastPage.js";
import "../../../../styles/assets/images/icons/material/designSystem/Link.js";
import "../../../../styles/assets/images/icons/material/designSystem/ListAlt.js";
import "../../../../styles/assets/images/icons/material/designSystem/ListAltFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/LocalLibraryFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/LocationOn.js";
import "../../../../styles/assets/images/icons/material/designSystem/LocationOnFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/LockOpen.js";
import "../../../../styles/assets/images/icons/material/designSystem/LockReset.js";
import "../../../../styles/assets/images/icons/material/designSystem/Logout.js";
import "../../../../styles/assets/images/icons/material/designSystem/Loop.js";
import "../../../../styles/assets/images/icons/material/designSystem/Mail.js";
import "../../../../styles/assets/images/icons/material/designSystem/MailFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Menu.js";
import "../../../../styles/assets/images/icons/material/designSystem/MonitorHeart.js";
import "../../../../styles/assets/images/icons/material/designSystem/MonitorHeartFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/MoreHoriz.js";
import "../../../../styles/assets/images/icons/material/designSystem/MoreVert.js";
import "../../../../styles/assets/images/icons/material/designSystem/NetworkCheck.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationImportant.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationImportantFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Notifications.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationsActive.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationsActiveFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationsOff.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationsOffFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Paid.js";
import "../../../../styles/assets/images/icons/material/designSystem/PaidFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Pending.js";
import "../../../../styles/assets/images/icons/material/designSystem/Percent.js";
import "../../../../styles/assets/images/icons/material/designSystem/Person.js";
import "../../../../styles/assets/images/icons/material/designSystem/PersonAdd.js";
import "../../../../styles/assets/images/icons/material/designSystem/PersonAddFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/PersonFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/PhoneDisabled.js";
import "../../../../styles/assets/images/icons/material/designSystem/PhoneDisabledFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/PointOfSale.js";
import "../../../../styles/assets/images/icons/material/designSystem/PriceChange.js";
import "../../../../styles/assets/images/icons/material/designSystem/PriceChangeFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/PriceCheck.js";
import "../../../../styles/assets/images/icons/material/designSystem/Publish.js";
import "../../../../styles/assets/images/icons/material/designSystem/PublishFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/PushPin.js";
import "../../../../styles/assets/images/icons/material/designSystem/PushPinFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/QuestionMark.js";
import "../../../../styles/assets/images/icons/material/designSystem/Receipt.js";
import "../../../../styles/assets/images/icons/material/designSystem/ReceiptFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Refresh.js";
import "../../../../styles/assets/images/icons/material/designSystem/RemoveCircle.js";
import "../../../../styles/assets/images/icons/material/designSystem/RemoveCircleFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Replay.js";
import "../../../../styles/assets/images/icons/material/designSystem/Reply.js";
import "../../../../styles/assets/images/icons/material/designSystem/Restore.js";
import "../../../../styles/assets/images/icons/material/designSystem/Route.js";
import "../../../../styles/assets/images/icons/material/designSystem/Save.js";
import "../../../../styles/assets/images/icons/material/designSystem/SaveFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Schedule.js";
import "../../../../styles/assets/images/icons/material/designSystem/Search.js";
import "../../../../styles/assets/images/icons/material/designSystem/Security.js";
import "../../../../styles/assets/images/icons/material/designSystem/Settings.js";
import "../../../../styles/assets/images/icons/material/designSystem/SettingsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Shield.js";
import "../../../../styles/assets/images/icons/material/designSystem/ShieldFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Smartphone.js";
import "../../../../styles/assets/images/icons/material/designSystem/SmartphoneFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Square.js";
import "../../../../styles/assets/images/icons/material/designSystem/SquareFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/SwapHorizontalCircle.js";
import "../../../../styles/assets/images/icons/material/designSystem/SwapHorizontalCircleFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/TableView.js";
import "../../../../styles/assets/images/icons/material/designSystem/Tune.js";
import "../../../../styles/assets/images/icons/material/designSystem/Undo.js";
import "../../../../styles/assets/images/icons/material/designSystem/Update.js";
import "../../../../styles/assets/images/icons/material/designSystem/Videocam.js";
import "../../../../styles/assets/images/icons/material/designSystem/VideocamFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ViewList.js";
import "../../../../styles/assets/images/icons/material/designSystem/ViewListFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Visibility.js";
import "../../../../styles/assets/images/icons/material/designSystem/VisibilityFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/VisibilityOffFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Warning.js";
import "../../../../styles/assets/images/icons/material/designSystem/WarningFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/WiFi.js";
import "../../../../styles/assets/images/icons/material/designSystem/WiFiOff.js";
import "../../../../styles/assets/images/icons/material/designSystem/Work.js";
import "../../../../styles/assets/images/icons/material/designSystem/WorkFilled.js";
import "../../../../styles/assets/images/icons/brands/GoogleG.js";
import "../../../../_commonjsHelpers-0c53d963.js";
import "react";
import "../../../../utils-f8d1c624.js";
import "../../../../Transition-c07376a3.js";
import "react-dom";
import "../../../../sass/sass.js";
import "../../../atoms/info/FlashBadge/FlashBadge.js";
import "../../../atoms/info/FlashSpinner/FlashSpinner.js";
import "../../../atoms/buttons/FlashButtonGeneric.js";
import "../../../../index-5e4e4f4b.js";
import "../../../../axios-5f69b112.js";
import "../../../../Button-9f0631d3.js";
import "../../../../hooks/useInsights/useInsights.js";
import "../../../../utils/noOp.js";
import "../../../../hooks/useLogger/constants.js";
import "../../../../hooks/useLogger/useLogger.js";
import "../../../../hooks/useLogger/LoggerContext.js";
import "../../../../hooks/useLogger/types.js";
import "../../../../hooks/useInsights/InsightsContext.js";
import "../../../../hooks/useInsights/useInsightsImpression.js";
import "../../../../index-2d889c01.js";
import "../../../../hooks/useInsights/utils.js";
import "../../../../utils/invokeFn.js";
import "../../../atoms/buttons/FlashButton/constants.js";
function FlashSideNav(props) {
  const { collapse, className, collapseMinWidth = 200, openButtonProps, children } = props, { isOpen, open } = collapse;
  return /* @__PURE__ */ jsx("div", { className: classNames(COMMON_CLASSNAME, "flash-side-nav d-inline-block", className), children: /* @__PURE__ */ jsxs("div", { className: "d-flex h-100", children: [
    /* @__PURE__ */ jsx(Collapse, { isOpen, horizontal: !0, className: "bg-primary", children: /* @__PURE__ */ jsx("div", { style: { minWidth: `${collapseMinWidth}px`, maxWidth: `${collapseMinWidth}px` }, className: "h-100", children }) }),
    /* @__PURE__ */ jsx(
      "div",
      {
        "data-testid": "flash-side-nav-hint-bar",
        className: classNames("side-nav-hint-bar h-100 border-end me-flash-200 bg-primary", {
          "side-nav-closed": !isOpen
        }),
        children: !isOpen && /* @__PURE__ */ jsx(
          FlashButton,
          {
            id: "flash-side-nav-show",
            LeadingIcon: ForwardRef,
            onClick: open,
            removePadding: !0,
            className: "p-flash-050 rounded-1 mt-flash-200 me-nflash-200 text-interactive",
            color: "secondary",
            ...openButtonProps
          }
        )
      }
    )
  ] }) });
}
export {
  FlashSideNav as default
};
//# sourceMappingURL=FlashSideNav.js.map
